/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Verify_HintInputs */



/**
* | output |
* | --- |
* | "Only the TXT record is needed to publish. You can add the traffic records afterwards; the site goes live automatically once they resolve." |
*
* @param {Canvas_Domain_Verify_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_verify_hint = /** @type {((inputs?: Canvas_Domain_Verify_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Verify_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Veröffentlichen genügt der TXT-Eintrag. Die Einträge für den Datenverkehr können Sie später ergänzen; die Seite geht automatisch online, sobald sie aufgelöst werden.")
	return /** @type {LocalizedString} */ ("Only the TXT record is needed to publish. You can add the traffic records afterwards; the site goes live automatically once they resolve.")
});